export default {
  translation: {
    // 'Common': {
    //
    // },
    // 'ServiceUser': {
    //     'Auth': {
    //         'insert_security_code' : 'Insert the security code'
    //     },
    // },

    // 소비자 앱
    insert_security_code: "승인코드 입력",
    valid_security_code: "정상적인 승인코드입니다. (인증횟수: {{count}}회)",
    security_code: "승인코드",
    confirm: "확인",
    expired_authentication: "인증 만료된 제품입니다",
    product_not_exist: "등록되지 않은 제품입니다.",
    product_not_exist_detail:
      "다시 인증을 시도하거나 브랜드사로 문의 부탁드립니다.",
    contact_customer_center: "자세한 사항은 고객센터로\n 문의 부탁드립니다",
    authenticating: "인증하는 중 입니다",
    wait_moment: "잠시만 기다려주세요",
    authentication_result: "인증결과",
    authenticated: "승인된 코드",
    manufacturer: "브랜드",
    distribution_details: "유통인수내역",
    scan_list: "인증내역",
    product_detail: "제품정보",
    distribution_history: "유통이력",
    hash_tags: "해시태그",
    shop_tags: "쇼핑몰 URL",
    company_tags: "회사 URL",
    no_hashtags: "지정 해시태그가 없습니다.",
    no_shopurl: "쇼핑몰 URL이 없습니다.",
    no_companyurl: "회사 URL이 없습니다.",
    has_event: " 에서 이벤트중이에요!",
    app_benefit_1: "M-check+ APP을 설치하고 제품을 인증하면",
    app_benefit_2: "여러가지 혜택을 받으실 수 있습니다.",
    app_benefit_3: "앱을 설치하고 이벤트에 참여하세요!",
    download_app: "APP 설치하기",
    view_on_web: "모바일웹으로 보기",
    incorrect_code: "인증오류!",
    cant_find_code: "승인코드가 확인되지 않습니다.",
    check_code_again: "제품에 부착된 승인코드를 재확인 해주세요.",
    inserted_code: "입력된 코드",
    contact_customer_center_error:
      "재확인에도 인증오류로 확인될 경우 구매처 또는 고객센터로 문의 바랍니다.",
    select_product_place: "고객님이 제품을 구입한 장소를 선택해주세요.",
    to_improve_service:
      "본 설문조사는 제품 및 서비스 문제점 개선을 위한\n 자료로 활용하기 위한 것입니다.",
    submit_survey: "설문제출",
    touch_object: "모델링을 터치하면 동영상이 재생됩니다.",
    scan_qr_code: "QR코드를 스캔해주세요",
    no_authentication: "인증내역이 없습니다",
    welcome: "환영합니다!",
    login_benefit: "로그인하신 고객께는 다양한 혜택을 드립니다",
    facebook_login: "페이스북 로그인",
    line_login: "라인 로그인",
    weibo_login: "웨이보 로그인",
    close: "닫기",
    product_code: "제품코드",
    product_info: "제품정보 보기",
    authenticationi_list: "인증내역",
    events_you_won: "이벤트당첨",
    sorry: "죄송합니다",
    once_per_id: "이벤트 참여는 한 ID당 한번만 가능합니다",
    ok: "확인",
    closed_event: "이벤트가 종료되었습니다",
    wait_for_next_event: "다음 이벤트를 기다려주세요",
    lotto_void_message: "다음 기회에",
    event_result: "이벤트 결과!",
    find_in_authentication_detail:
      "이벤트 당첨내역에 대한 프로모션 바코드는 인증내역에서 확인할 수 있습니다.",
    you_win: "당첨!",
    turn_roulette: "돌려라 룰렛",
    scratch_lotto: "복권을 긁어주세요!",
    sns_login: "소셜 로그인",
    login_required_for_event:
      "이벤트에 참여하시기 위해서는 소셜로그인이 필요합니다.",
    turn_on_light: "어두운 곳에서는\n 플래시를 밝히세요.",
    scan_qr_or_tag_nfc:
      "QR코드를 스캔하거나 NFC모드로\n 태그하여 정품을 인증하세요.",
    check_3d_modeling: "AR 스캔을 통해 제품의\n 3D 모델링을 확인 할 수 있어요!",
    check_through_authentication:
      "인증결과를 통해서 제품 브랜드 정보와\n 상세정보를 확인 할 수 있어요!",
    check_first_authentication:
      "내가 첫 인증자인지\n 인증횟수를 통해서 확인하세요!",
    check_the_way_distributed:
      "어떤 경로로 이 제품을\n 유통했는지 확인 할 수 있어요.",
    scroll_to_check_detail:
      "스크롤을 내려서 제품 상세정보를\n 확인 할 수 있어요!",
    participate_for_benefit:
      "정품인증한 브랜드에서 진행중인 이벤트에 참가하고\n 특별한 혜택을 받아가세요!",
    log_in: "로그인하기",
    register: "회원가입",

    // CMS
    id: "아이디",
    password: "비밀번호",
    enter_id: "아이디를 입력해주세요",
    enter_password: "비밀번호를 입력해주세요",
    company_login: "제휴사 로그인",
    admin_login: "ADMIN 로그인",
    statistics: "통계",
    member_management: "회원관리",
    product_management: "제품관리",
    track_trace_management: "유통관리",
    operation_management: "운영관리",
    issue_codes: "코드발행",
    statistics_overview: "OVERVIEW",
    statistics_by_manufacturer: "브랜드별 통계",
    statistics_by_products: "제품별 통계",
    by_manufacturer: "브랜드",
    by_distributor: "유통자",
    by_customer: "소비자",
    company_info: "제휴사 정보",
    product: "제품",
    event: "이벤트",
    event_management: "이벤트 관리",
    track_trace: "유통관리",
    abnormal_authentication: "Abnormal Info",
    abnormal_location: "비정상인증 구매처 조회",
    admin_member: "ADMIN 회원",
    push_message: "전체 Push 발송",
    recent_year: "최근 1년 통계",
    total_manufacturer: "총 브랜드",
    total_product: "총 제품군",
    total_tags: "총 발행건수",
    total_authentication: "총 인증건수",
    top5_by_country: "국가별 인증률 TOP5",
    top5_by_product: "제품별 인증률 TOP5",
    country_name: "국가명",
    authentication_rate: "인증률",
    product_name: "제품명",
    statistics_by_map: "지도별 인증통계",

    register_company: "제휴사 등록",
    company_search_keyword: "제휴사명/제휴사#/ID",
    search: "조회",
    total: "총",
    selected_member_status: "선택한 회원의 상태를",
    change: "변경",
    normal: "정상",
    block: "중지",
    select: "선택",
    country: "국가",
    company_logo: "제휴사 로고",
    company_name: "제휴사",
    ID: "ID",
    member_in_charge: "담당자",
    status: "상태",
    registered_date: "등록일",
    register_distributor: "유통자 등록",
    distributor_search_keyword: "이름/ID",
    affiliate: "소속제휴사",
    customer_search_keyword: "국가/이름/ID",
    customer_name: "이름",
    customer_center: "고객센터",
    company_register: "제휴사 등록",
    company: "제휴사",
    company_code: "제휴사 코드",
    address: "주소",
    contact: "본사연락처",
    person_in_charge: "담당자",
    contact_number: "담당자연락처",
    brand_logo: "브랜드 로고",
    upload_file: "파일업로드",
    preview: "미리보기",
    recommended_image_size:
      "이미지 권장 규격 : 1080px*216px / 0.5MB 이하, .png, .gif, .svg 배경투명화",
    business_license: "사업자등록증",
    bank_account_copy: "통장사본",
    telephone: "전화번호",
    operation_time: "운영시간",
    edit: "수정",
    distributor: "유통자",
    product_list: "제품이력",
    product_number: "제품#",
    number_of_authentication: "인증 수",
    contacts: "연락처",
    select_affiliate: "제휴사 선택",
    distributor_info: "유통자 정보",
    name: "이름",
    person_in_charge_affiliate: "제휴담당자",
    manufacturing_date: "제조일",
    authentication_location: "인증위치",
    authentication_date: "인증일",
    authentication_history: "인증이력",
    attached_events: "이벤트당첨",
    customer_info: "소비자 정보",
    email: "이메일",
    gender: "성별",
    birth_year: "생년",
    event_type: "이벤트 종류",
    event_name: "이벤트명",
    items: "건",

    unauthorized: "미승인",
    approval: "승인",
    stop: "정지",
    expiration: "만료",
    request: "승인요청",
    product_register: "제품 등록",
    product_search_keyword: "제휴사명/제품#/제품명",
    selected_product_status: "선택한 제품의 상태를",
    design_settings: "디자인설정",
    set_language_as_default: "언어를 기본 페이지로 설정",
    representative_image: "대표이미지",
    //// 신규 추가
    admin_product_product_name_placeholder: "제품 이름",
    admin_product_add_image_box: `이미지<br/>추가`,
    admin_product_hashtag_placeholder: `#해시태그`,
    admin_product_authentication_placeholder: `인증 횟수 (최대 40자)`,
    admin_product_3d_model_placeholder: `파일 규격 20MB 이하(.glb)`,
    admin_product_bgm_placeholder: `파일 규격 2MB 이하(.mp3, .acc)`,
    admin_product_video_placeholder: `동영상 파일 규격 50MB 이하(.avi, .mp4)`,
    ////////////
    add_image: "이미지 추가",
    add_image_br: "이미지\n추가",
    recommended_representative_images:
      "대표 이미지 권장 규격 : 1080px*786px, 이미지 크기 0.5MB 이하\n 최대 10개 입력 가능",
    detailed_information: "상세정보",
    recommended_detailed_image:
      "상세정보 이미지 권장 규격 : 가로 1080px, 이미지크기 0.5MB 이하",
    tag: "태그",
    authentication_information: "인증정보",
    maximum_number_of_authentication: "최대인증횟수",
    regardless_number_of_authentication:
      "-1일 때는 인증 수에 상관없이 계속 인증 됩니다.",
    magnetic_authentication_guide: "자석인증안내",
    connection_url: "연결 URL",
    authentication_period: "인증기간",
    start_date: "시작일",
    expiration_date: "만료일",
    "3d_model": "3D 모델",
    recommended_file_size:
      "파일 규격 20MB 이하(.3dm, .3ds, CATpart, igs, .MODEL, .obj)",
    video: "동영상",
    edit_feedback: "Feedback 편집",
    survey_title: "설문조사 제목",
    survey_contents: "설문조사 내용",
    survey_item: "설문조사 항목",
    input: "입력",

    authentication_stage: "인증단계",
    genuine_mark: "정품마크",
    layout: "레이아웃",
    authentication_stage_design: "인증단계 디자인",
    add_design: "디자인 추가",
    remove: "삭제",
    register_product: "제품 등록",
    setting_product_permissions: "제품 권한 설정",
    basic_authentication: "기본 인증",
    ar: "AR",
    survey: "설문조사",
    lottery: "복권",
    roulette: "룰렛",
    sample_product_qr_code: "Sample 제품 QR Code",
    download_qr: "QR 다운",
    copy_qr_link: "QR 링크 복사",
    image_recommendation_specification:
      "이미지 권장 규격 : 600px*144px / 0.5MB 이하, .png, .gif, .svg 배경투명화",
    genuine_mark_design: "정품마크 디자인",
    register_event: "이벤트 등록",
    event_search_keyword: "제휴사명/제품#/제품명",
    selected_event_status: "선택한 이벤트의 상태를",
    type: "종류",
    event_information: "이벤트정보",
    event_image: "이벤트 이미지",

    attach_event_image: "이벤트 이미지를 첨부하세요",
    enter_url: "URL 입력",

    event_image_specification:
      "이미지 규격 1080px*1920px, 파일 용량 0.5MB 이하",
    event_link: "이벤트 링크",
    event_info: "이벤트 설명",
    event_period: "이벤트 기간",
    time: "시간",
    event_title: "이벤트 제목",
    maximum_15_characters: "띄어쓰기 포함 최대 15자",
    maximum_21_characters: "띄어쓰기 포함 최대 21자",
    number_of_goods: "상품 수",
    two_divisions: "2분할",
    three_divisions: "3분할",
    quadrant: "4분할",
    five_divisions: "5분할",
    six_divisions: "6분할",
    product_type: "상품 타입",
    prize_name: "상품명",
    product_description: "상품설명",
    maximum_byte: "최대 18 byte",
    probability: "확률",
    acceptable_probability: "0.001% - 99% 입력 가능",
    commodity_quantity: "상품 수량",
    change_to_zero_probability: "소진시 확률 0으로 변경",
    promotion_code: "프로모션코드",
    promotion_code_or_barcode: "프로모션코드/바코드 중\n 1개만 등록 가능",
    barcode_image: "바코드 이미지",
    fail: "꽝",
    image: "이미지",
    text: "텍스트",
    prize_image_specification: "(규격 480px*318px) 파일용량 0.5MB 이하",

    period: "기간",
    specifying_distributor: "유통자 지정",
    download_excel: "엑셀 다운로드",
    product_group: "제품군",
    quantity: "수량",
    select_product: "제품 선택",
    register_manufacturing_sites: "제조지 등록",
    optional: "선택사항",
    add: "추가",
    search_address: "주소지 검색",
    setting_authentication_period: "인증가능기간 설정",
    specifying_authentication_zone: "인증지역 지정",
    view_map: "지도보기",
    undesignated: "미지정",
    cut_off: "차단",
    many_positions: "많은 위치",
    a_number_of_authentications: "많은 인증",
    abnormal_authentication_statistics: "비정상인증 통계",
    place_of_purchase: "구매처",
    register_admin: "ADMIN 등록",
    authorization: "권한",
    member_level: "회원등급",
    completed: "발송완료!",
    message: "메세지 ",
    including_box_codes: "BOX코드 포함",
    individual_product: "개별제품",
    automatic: "자동",
    number_of_digits: "자리수",
    manual: "수동",
    upload_excel_file: "엑셀업로드",
    number_of_individual_products: "개별제품 수량",
    box_level: "BOX레벨",
    box_ea: "BOX 수량",
    box_capacity: "BOX 1개당 담는\nBOX 수량",
    box_capacity_lv1: "BOX 1개당 담는\n개별제품 수량",

    issue_codes_completed: "코드발행완료",
    issue_codes_failed: "코드발행실패",
    code_issue_info: "엑셀은 50만개씩 나누어 엑셀 저장됩니다.",

    manufacturing_history: "제조이력",
    abnormal_authentication_history: "비정상인증이력",
    number_of_authentications: "인증 횟수",
    certifier: "인증자",

    max_number_of_authentications: "인증 횟수 (최대 40자)",
    recommended_music_file_size: "파일 규격 2MB 이하(.mp3, .acc)",
    recommended_video_file_size: "동영상 파일 규격 50MB 이하(.avi, .mp4)",

    // 유통자 앱
    for_distributor: "유통자 서비스",
    forgot_password: "비밀번호를 잊으셨나요?",
    contact_company: "소속된 브랜드사에 문의해주세요.",
    login: "로그인",
    hello: "안녕하세요",
    list_of_taking_over: "인수받을 내역",
    none_of_list: "인수받을 내역이 없습니다.",
    and: "외",
    select_unit: "단위선택",
    change_product_status: "제품상태 변경",
    change_box_status: "박스상태 변경",
    hand_over: "인계하기",
    take_over: "인수받기",
    handover: "인계",
    takeover: "인수",
    product_authentication: "정품확인",
    box: "박스",
    individual: "제품단위",
    working_box_unit: "박스단위로 작업을 수행합니다",
    working_Individual_unit: "제품단위로 작업을 수행합니다",
    move_product: "제품 이동",
    move_product_to_another: "다른 박스로 제품을 이동",
    insert_product: "제품 추가",
    insert_product_to_this: "박스에 제품을 새로 추가",
    remove_product: "제품 제거",
    remove_product_from_this: "박스에서 제품을 제거",
    move_box_to_another_level: "박스 이동",
    move_box_to_another_same_level: "다른 대박스로 소박스를 이동",
    insert_box: "박스 추가",
    insert_box_to_higher_level: "대박스에 소박스를 새로 추가",
    remove_lower_level_box: "박스 제거",
    remove_lower_level_box_from_this: "대박스에서 소박스를 제거",
    cancel: "취소",
    check: "확인",
    complete: "완료",
    takeover_list: "인수내역",
    handover_list: "인계내역",
    authentication_list: "정품확인내역",
    distributed_handover_details: "유통인계내역",
    distributed_takeover_details: "유통인수내역",
    distributor_list: "유통자 내역"
  }
};
